"use strict";

require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var w3c_keys_1 = require("w3c-keys");

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var IconLink_1 = require("../../molecules/IconLink");

var Icon_1 = require("../Icon");

var Pagination =
/** @class */
function (_super) {
  __extends(Pagination, _super);

  function Pagination() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.pageLinks = [];

    _this.handleKey = function (e) {
      var _a;

      utils_1.SelectionNavHelper.useKeyMap(e, (_a = {}, _a[w3c_keys_1.Key.ArrowRight] = function (elms) {
        return elms.next().focus();
      }, _a[w3c_keys_1.Key.PageDown] = function (elms) {
        return elms.next().focus();
      }, _a[w3c_keys_1.Key.ArrowLeft] = function (elms) {
        return elms.prev().focus();
      }, _a[w3c_keys_1.Key.PageUp] = function (elms) {
        return elms.prev().focus();
      }, _a[w3c_keys_1.Key.Home] = function (elms) {
        return elms.first().focus();
      }, _a[w3c_keys_1.Key.End] = function (elms) {
        return elms.last().focus();
      }, _a[w3c_keys_1.Key.Enter] = function (elms) {
        elms.curr().click();

        if (elms.curr() === _this.leftArrow && _this.props.activePage - 1 <= 1) {
          // focus first page when left arrow is set to disabled
          // else focus will be lost
          elms.next().focus();
        } else if (elms.curr() === _this.rightArrow && _this.props.activePage + 1 >= _this.props.numPages) {
          // focus last page when left arrow is set to disabled
          // else focus will be lost
          elms.prev().focus();
        }
      }, _a), utils_1.SelectionNavHelper.getFocusHandler(__spreadArrays([!(_this.props.activePage <= 1) && _this.leftArrow], _this.pageLinks, [!(_this.props.activePage >= _this.props.numPages) && _this.rightArrow]).filter(Boolean), document.activeElement));
    };

    return _this;
  }

  Pagination.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        numPages = _a.numPages,
        activePage = _a.activePage,
        _onClick = _a.onClick,
        hideArrows = _a.hideArrows,
        className = _a.className,
        id = _a.id,
        children = _a.children;
    this.pageLinks = [];
    var pageSymbols = numPages <= 7 ? Array(numPages).fill(0).map(function (_, i) {
      return i + 1;
    }) : [1, activePage > 4 ? "…" : 2, Math.min(Math.max(activePage - 1, 3), numPages - 4), Math.min(Math.max(activePage, 4), numPages - 3), Math.min(Math.max(activePage + 1, 5), numPages - 2), activePage < numPages - 3 ? "…" : numPages - 1, numPages];
    return React.createElement("div", {
      id: id,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "pagination", className])
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "pagination-label"
    }, children), React.createElement("nav", {
      className: CSSPrefix_1.lsgPre + "pagination-pages",
      "aria-label": utils_1.Localization.texts.lsg.component.SliderPagination.pagination
    }, !hideArrows && React.createElement(IconLink_1.IconLinkGroup, {
      direction: IconLink_1.IconLinkGroup.Directions.HORIZONTAL
    }, React.createElement(IconLink_1.IconLink, {
      iconName: Icon_1.Icon.Names.interaction_arrows_chevronLeft,
      look: IconLink_1.IconLink.Looks.NO_TEXT,
      color: IconLink_1.IconLink.Colors.SECONDARY,
      onClick: function onClick(e) {
        return _onClick(activePage - 1, e);
      },
      onKeyDown: this.handleKey,
      refCallback: function refCallback(r) {
        return _this.leftArrow = r;
      },
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "pagination-arrow", CSSPrefix_1.lsgPre + "pagination-arrow-left"]),
      disabled: activePage <= 1
      /* disabled link needed for a11y */

    }, utils_1.Localization.texts.lsg.component.SliderPagination.previousPage)), React.createElement("ul", {
      className: CSSPrefix_1.lsgPre + "pagination-pagelist"
    }, pageSymbols.map(function (symbol, i) {
      var isNumber = typeof symbol === "number";
      return symbol && React.createElement("li", {
        className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "pagination-page", activePage === symbol && CSSPrefix_1.lsgPre + "pagination-page__active"]),
        key: i
      }, React.createElement("a", {
        onClick: isNumber ? function (e) {
          return _onClick(symbol, e);
        } : undefined,
        onKeyDown: isNumber ? _this.handleKey : undefined,
        ref: function ref(r) {
          if (isNumber) {
            _this.pageLinks[i] = r;
          }
        },
        "aria-current": activePage === symbol ? "page" : undefined,
        tabIndex: isNumber ? 0 : -1
      }, symbol));
    })), !hideArrows && React.createElement(IconLink_1.IconLinkGroup, {
      direction: IconLink_1.IconLinkGroup.Directions.HORIZONTAL
    }, React.createElement(IconLink_1.IconLink, {
      iconName: Icon_1.Icon.Names.interaction_arrows_chevronRight,
      look: IconLink_1.IconLink.Looks.NO_TEXT,
      color: IconLink_1.IconLink.Colors.SECONDARY,
      onClick: function onClick(e) {
        return _onClick(activePage + 1, e);
      },
      onKeyDown: this.handleKey,
      refCallback: function refCallback(r) {
        return _this.rightArrow = r;
      },
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "slider-pagination-arrow", CSSPrefix_1.lsgPre + "slider-pagination-arrow-right"]),
      disabled: activePage >= numPages
      /* disabled link needed for a11y */

    }, utils_1.Localization.texts.lsg.component.SliderPagination.nextPage))));
  };

  Pagination.defaultProps = {
    onArrowRightClick: function onArrowRightClick() {
      /* empty */
    },
    onArrowLeftClick: function onArrowLeftClick() {
      /* empty */
    }
  };
  return Pagination;
}(React.Component);

exports.Pagination = Pagination;